import { render } from "./InputMultiple.vue?vue&type=template&id=844fb6d4"
import script from "./InputMultiple.vue?vue&type=script&lang=js"
export * from "./InputMultiple.vue?vue&type=script&lang=js"
script.render = render

export default script